import { createApi } from "@reduxjs/toolkit/query/react";
import { spotFinder } from "../app/endpoints";
import axiosBaseQuerySpotfinder from "./axiosBaseQuerySpotfinder";

export const downloadInvoiceAPI = createApi({
  reducerPath: "downloadInvoiceAPI",
  baseQuery: axiosBaseQuerySpotfinder({
    baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL,
  }),
  tagTypes: ["downloadInvoice"],
  endpoints: (builder) => ({
    downloadInvoice: builder.mutation({
      query: ({ bookingId, token }: { bookingId: string; token: string }) => {
        console.log("downloadInvoice called with:", { bookingId, token });
        return {
          url: `${spotFinder.invoiceDetailController.downloadInvoice}/${bookingId}`,
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob", // Ensure the response type is set to 'blob'
        };
      },
      async onQueryStarted({ bookingId, token }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled; // Wait for the query to finish

          // Handle the successful download
          if (data) {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `invoice-${bookingId}.pdf`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            console.log("Invoice downloaded successfully");
          }
        } catch (error) {
          // Handle the error case
          console.error("Error while downloading the invoice:", error);
        }
      },
    }),
  }),
});

export const { useDownloadInvoiceMutation } = downloadInvoiceAPI;
